export interface iInformationAccordion {
  Items: string[];
  SetItems: (newItems: string[]) => void;
}

export const initialInformationAccordionValues: iInformationAccordion = {
  Items: ['item-1', 'item-2'],
  SetItems: (newItems: string[]) => {}
}
